// extracted by mini-css-extract-plugin
module.exports = {"margin-button":"IntegrationProjectsActionsColumn_margin-button__SOm3P","action-button":"IntegrationProjectsActionsColumn_action-button__r64p8"};